export default ($) => {
  const listingsDeduplicated = !(typeof(window.Raise.data.optimizely) === 'undefined')
    && window.Raise.data.optimizely
    && window.Raise.data.optimizely.deduplicate;

  return new Promise((resolve) => {
    const checkAndResolve = () => {
      if(!listingsDeduplicated || $('.card').length) {
        resolve($);
      } else {
        setTimeout(checkAndResolve, 500);
      }
    };

    checkAndResolve();
  });
};
